import React from 'react';
 
export const AppReducer = (state, action) => {
   switch(action.type) {
       case 'SET_ERR':
           // Keep errorMessage for any page still rendering it inline; when a real
           // message is set, also raise a notification (with a fresh key so the
           // same text re-triggers the toast). A falsy payload is a clear: wipe the
           // inline message but do NOT raise a toast.
           return {
            ...state,
            errorMessage: action.payload || '',
            notification: action.payload
              ? { message: action.payload, severity: 'error', key: Date.now() }
              : state.notification
           }
       case 'NOTIFY':
           return {
            ...state,
            notification: { ...action.payload, key: Date.now() }
           }
       case 'SET-FLAG':
           return {
            ...state,loading:action.payload
           }
       default:
           return state;
   }
}